
// JS Dependencies
//import { Carousel } from 'bootstrap';
import 'jquery';
import 'jquery-ajax-unobtrusive';
import Vue from 'vue';
import vueCustomElement from 'vue-custom-element'
import './core/editor'

// CSS Dependencies
/*import 'swiper/swiper-bundle.css'*/
/*import "@fancyapps/ui/dist/fancybox.css";*/
import '../css/scss/main.scss';


Vue.use(vueCustomElement);

//window.Carousel = Carousel;


//lazy load images
document.addEventListener("DOMContentLoaded", function() {
  var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));

  if ("IntersectionObserver" in window) {
    let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          let lazyImage = entry.target;
          lazyImage.src = lazyImage.dataset.src;
          //lazyImage.srcset = lazyImage.dataset.srcset;
          lazyImage.classList.remove("lazy");
          lazyImageObserver.unobserve(lazyImage);
        }
      });
    });

    lazyImages.forEach(function(lazyImage) {
      lazyImageObserver.observe(lazyImage);
    });
  } else {
    // Possibly fall back to event handlers here
  }
});

//branches
window.branchSearchEvents = function () {
    function changeIframe(q) {
        var iframesrc = 'https://www.google.com/maps/embed/v1/place?key=AIzaSyAzSQy8kgDZjichpyj7doG4kbOL11htiCo&language=he&q=' + q;
        if (document.getElementById("gmaps").src !== iframesrc) {
            document.getElementById("gmaps").src = iframesrc;
        }
    }

    $(document).on("click", ".branches [data-branchid]", function (e) {
        e.preventDefault();
        e.stopPropagation();
        $('.branches li .details').removeClass('show');
        var selectedBranch = $(this);
        changeIframe(selectedBranch.data('address'));
        $('.branches li').removeClass('sel');
        selectedBranch.closest('li').addClass('sel');
    });

    $(document).on("click", ".citybtn", function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (self.selectedBranch().ID() !== '') {
            $('.branches [data-branchid="' + self.selectedBranch().ID() + '"]').trigger('click');
            basketVM.Branches([]);
        }
    });

    $(document).on("click", ".branchsearch .name", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var selectedBranch = $('.branches [data-branchid="' + $(this).data('branch-id') + '"]');
        changeIframe(selectedBranch.data('address'));
        $('.branches li').removeClass('sel');
        selectedBranch.closest('li').addClass('sel');
        basketVM.Branches([]);
    });

    $(document).on('keyup', '.branchsearch', function (e) {
        if (e.keyCode === 13 || e.keyCode === 38 || e.keyCode === 40) {
            e.preventDefault();
            if (e.keyCode === 13) {
                if (self.selectedBranch().ID() !== '') {
                    $('.branches [data-branchid="' + self.selectedBranch().ID() + '"]').trigger('click');
                    basketVM.Branches([]);
                } else {
                    //$("#searchform").submit();
                }
                return;
            }
            if (e.keyCode === 38) {
                if (self.selectedIndex - 1 > -1) {
                    self.setSelectedBranch(basketVM.Branches()[self.selectedIndex - 1]);
                    self.selectedIndex--;
                }
                return;
            }
            if (e.keyCode === 40) {
                if (self.selectedIndex + 1 < basketVM.Branches().length) {
                    self.setSelectedBranch(basketVM.Branches()[self.selectedIndex + 1]);
                    self.selectedIndex++;
                }
                return;
            }
        }
        if (e.target.name === 'keyword') {
            var valI = $(this).find('input[type="search"]').val();
            if (valI.length > 2) {
                basketVM.loadBranches(valI);
                return;
            } else {
                basketVM.Branches([]);
            }
        }
    });
};